// fetchUserThemes.ts
import FetchData from '../Components/ServerCall/FetchData';

export interface RawThemeResponse {
  themeId: string;
  themeName: string;
  theme: string;
  isDefault: boolean;
}

export interface ParsedTheme {
  themeId: string;
  themeName: string;
  background: string;
  tableHeaderBackground: string;
  colors: string[];
  isDefault?: boolean;
}

export interface FetchUserThemesResult {
  themes: ParsedTheme[];
  defaultThemeId: string | null;
}

let cachedResult: FetchUserThemesResult | null = null;

const fetchUserThemes = async (): Promise<FetchUserThemesResult> => {
  if (cachedResult) return cachedResult;

  try {
    const response = await FetchData({
      requestType: 'noData',
      method: 'GET',
      url: 'theme/user',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });

    if (response.status && Array.isArray(response.data)) {
      const themes: ParsedTheme[] = response.data.map((theme: RawThemeResponse) => {
        const parsed = JSON.parse(theme.theme);

        return {
          themeId: theme.themeId,
          themeName: theme.themeName,
          background: parsed.background ?? '#fff',
          tableHeaderBackground: parsed.tableHeaderBackground ?? '#f7f7f7',
          colors: parsed.colors ?? [],
          isDefault: theme.isDefault,
        };
      });

      const defaultThemeId = themes.find((t) => t.isDefault)?.themeId ?? null;

      cachedResult = { themes, defaultThemeId };
      return cachedResult;
    }
  } catch (err) {
    console.error('Error fetching user themes:', err);
  }

  return { themes: [], defaultThemeId: null };
};

export const clearCachedThemes = () => {
  cachedResult = null;
};

export default fetchUserThemes;
